<template>
    <div class="ellipsisDiv" :title="text">
        {{ text || '-'}}
    </div>
  </template>
  
  <script>
  export default {
    name: "ellipsisDiv",
    props: {
      text: {
        type: String,
        default: () => ''
      }
    },
    data() {
      return {
      }
    }
}
  </script>
  
  <style scoped>
  .ellipsisDiv{
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  </style>
  